import { marked } from 'marked';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, Modal, ModalHandle } from 'Mri.Web.Common';
import * as React from 'react';
import { BsGearFill } from '@react-icons/all-files/bs/BsGearFill';
import { Button } from 'reactstrap';
import changelog from '../../../../CHANGELOG.md';
import { AppStore } from './AppStore';

export interface IUpdateModalProps {
    readonly modalHandle: ModalHandle;
}

@autoinject
@observer
export class UpdateModal extends React.Component<IUpdateModalProps> {
    public render() {
        return (
            <Modal
                title={this.title}
                modalHandle={this.props.modalHandle}
                onOpened={this.loadAsync}
                bodyClass="p-0"
                footer={this.footer}
            >
                <div className="px-3 pt-3">
                    <div className="update-markdown" dangerouslySetInnerHTML={{ __html: this.changeLog }} />
                </div>
            </Modal>
        );
    }

    @bind
    @action
    private async loadAsync() {
        const response = await fetch(changelog);
        let changeLog = await response.text();
        changeLog = changeLog.slice(changeLog.indexOf('##'), changeLog.length);

        // Internal app is for MRI employees - show internal section but strip comment markers
        changeLog = changeLog
            .replace(/<!--\s*MRI-INTERNAL-START\s*-->/g, '')
            .replace(/<!--\s*MRI-INTERNAL-END\s*-->/g, '');

        const renderer = new marked.Renderer();
        renderer.heading = this.headerItemRenderer;
        renderer.list = this.listRenderer;
        renderer.listitem = this.listItemRenderer;

        this.changeLog = marked(changeLog, { gfm: true, renderer });
    }

    private listItemRenderer(text: string) {
        if (/^\s*\[[x ]\]\s*/.test(text)) {
            text = text
                .replace(/^\s*\[ \]\s*/, '<input type="checkbox" disabled class="align-middle"></input> ')
                .replace(/^\s*\[x\]\s*/, '<input type="checkbox" checked disabled class="align-middle"></input> ');
            return '<li class="ps-0 py-2">' + text + '</li>';
        } else {
            return '<li>' + text + '</li>';
        }
    }

    private listRenderer(body: string) {
        return '<ul class="p-0">' + body + '</ul>';
    }

    private headerItemRenderer(text: string) {
        return '<h2 class="text-center">' + text + '</h2>';
    }

    @bind
    private async close(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();
        this.props.modalHandle.close();
    }

    //Private Fields
    @computed
    private get title() {
        return (
            <span className="text-header fw-bold">
                <BsGearFill /> Update {this.appStore.storage.version}
            </span>
        );
    }

    @computed
    private get footer() {
        return (
            <Button color="primary" onClick={this.close}>
                Ok!
            </Button>
        );
    }

    @observable
    private changeLog: any;
    @inject
    private appStore!: AppStore;
}
